export default {
  // Possible sizes for Geometric Background components based on the width. (one-quarter-width, two-quarter-width, three-quarter-width and full-size).
  componentSize: 'one-quarter-width'
}
